export const RUTA_USUARIO = {
  preingresocaladounodos: {
    redirectTo: '/preingresoCalado/1-2',
    autoLogin: true
  },
  preingresocaladotrescuatro: {
    redirectTo: '/preingresoCalado/3-4',
    autoLogin: true
  },
  brutochofer: {
    redirectTo: '/pesadoBruto',
    autoLogin: true
  },
  destarechofer: {
    redirectTo: '/pesadoDestare',
    autoLogin: true
  },
  lperez: {
    redirectTo: '/calado/egresoqrcalado',
    autoLogin: false
  },
  ealvarez: {
    redirectTo: '/calado/egresoqrcalado',
    autoLogin: false
  },
  preingresocalado: {
    redirectTo: '/accesoPreingreso',
    autoLogin: false
  }
}
